/**
 * Общий короткий тон для чатов и центра уведомлений. Один AudioContext живёт
 * до закрытия вкладки; настройки пользователя и частоту вызовов определяет store.
 * Заблокированные autoplay-сигналы пропускаются, а не копятся до первого клика.
 */
let audioContext;

function getAudioContext() {
  const Context = window.AudioContext || window.webkitAudioContext;
  if (!Context) return null;
  if (!audioContext || audioContext.state === "closed") audioContext = new Context();
  return audioContext;
}

// Вызывать из пользовательского действия: браузер разрешает дальнейший live-звук.
export async function unlockNotificationSound() {
  try {
    const context = getAudioContext();
    if (context && context.state !== "running") await context.resume();
    return context?.state === "running";
  } catch {
    return false;
  }
}

// Возвращает false, если Web Audio недоступен или браузер ещё не разрешил звук.
export function playNotificationSound() {
  try {
    const context = getAudioContext();
    if (!context || context.state !== "running") return false;

    const oscillator = context.createOscillator();
    const gain = context.createGain();
    const startTime = context.currentTime;

    oscillator.type = "sine";
    oscillator.frequency.setValueAtTime(880, startTime);
    gain.gain.setValueAtTime(0.0001, startTime);
    gain.gain.exponentialRampToValueAtTime(0.08, startTime + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, startTime + 0.22);
    oscillator.connect(gain);
    gain.connect(context.destination);
    oscillator.onended = () => {
      oscillator.disconnect();
      gain.disconnect();
    };
    oscillator.start(startTime);
    oscillator.stop(startTime + 0.24);
    return true;
  } catch {
    return false;
  }
}
